module.exports = __webpack_public_path__ + "img/chess_chessblack1.886d62db.png";